module.exports = __webpack_public_path__ + "media/images/web/banner-footer-7f48cf3ace93e021db6066185d8daddf.jpg";